import {connect} from "react-redux";
import React, {useEffect, useState} from "react";
import {accountActions} from "../../../redux/actions/account";
import {footerActions} from "../../../redux/actions/footer";
import {useLocation, useNavigate} from "react-router-dom";
import * as api from "../../../api/api";
import Loading from "../../common/Loading";
import { Button } from '../../../components/button'

import { getLogoUrl } from "../../../utils/logos";
const COMPANY_CODE = process.env.REACT_APP_COMPANY_CODE;
const EXPLICIT_FILE = process.env.REACT_APP_APP_LOGO || "";

const Login = (props) => {
	const [userId, setUserId] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();
	const {search} = useLocation();

	const logo = getLogoUrl({ code: COMPANY_CODE, file: EXPLICIT_FILE, fallback: 'default.svg' });

	const validation = () => {
		if (!userId || !password) return;
		const login = {
			id: userId,
			password: password
		}
		acceptLogin(login);
	}

	const acceptLogin = (login) => {
		setLoading(true);
		
		// 로그인 전에 이전 세션 정보 초기화
		props.initAccount();
		
		const params = {
			companyCode: COMPANY_CODE,
			userId: login.id,
			password: login.password
		}
		api.login(params).then(result => {
			const {data, status, statusText} = result;
			if (status === 200) {
				if (data.status === 1) {
					props.setAccount(data);
					goMain()
				}
				else {
					window.alert("로그인 불가")
				}
			}
			else {
				window.alert(statusText);
			}
		})
			.catch(ex => {
				window.alert(ex.response.data);
			})
			.finally(() => {
				setLoading(false)
			})
	}

	const goMain = () => {
		navigate("/dashboard");
	}

	return (
		<div className="bg-black min-h-screen flex items-center justify-center">
			{loading ? <Loading /> : null}
			<div className="w-full max-w-md bg-zinc-900 rounded-2xl shadow-xl p-8">
				<div className={"flex flex-row gap-2 items-center mb-4"}>
					<img className={"w-28"} src={logo} alt={""} />
					<span className="text-2xl font-bold text-white">Admin Login</span>
				</div>
				<form className="space-y-6" onSubmit={e => {e.preventDefault(); validation();}}>
					<div>
						<label className="block text-sm font-medium text-gray-300 mb-1">ID</label>
						<input
							className="w-full px-4 py-2 border-1 border-zinc-700 rounded-lg bg-zinc-800 text-zinc-100 placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
							type="text"
							placeholder="ID"
							value={userId}
							onChange={(event) => setUserId(event.target.value)}
							autoComplete="username"
						/>
					</div>
					<div>
						<label className="block text-sm font-medium text-gray-300 mb-1">Password</label>
						<input
							className="w-full px-4 py-2 border-1 border-zinc-700 rounded-lg bg-zinc-800 text-zinc-100 placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
							type="password"
							placeholder="Password"
							value={password}
							onChange={(event) => setPassword(event.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault()
									validation()
								}
							}}
							autoComplete="current-password"
						/>
					</div>
					<Button type="submit" className="w-full">
						Login
					</Button>
				</form>
			</div>
		</div>
	)
}

const mapDispatchToProps = (dispatch) => {
	return {
		setAccount: (account) => {
			dispatch(accountActions.setAccount(account));
		},
		initAccount: () => {
			dispatch(accountActions.initAccount());
		},
		initFooterMenu: () => {
			dispatch(footerActions.initFooterMenu());
		},
		addFooterMenu: (menu) => {
			dispatch(footerActions.addFooterMenu(menu));
		},
		dispatch
	}
}

const mapStateToProps = (state) => {
	const {account, footer} = state;
	return {
		account, footer
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Login)